export default __webpack_public_path__ + "static/media/clear.40cdb0b6.svg";